import React from 'react';
import GradientWrapper from './GradientWrapper';
interface GradientChipProps {
  children: ReactNode;
  onClick?: () => void;
  size?: 'xs' | 'sm';
  className?: string;
}
const GradientChip: React.FC<GradientChipProps> = ({
  children,
  onClick,
  size = 'sm',
  className = ''
}) => {
  const sizeClasses = {
    xs: 'text-xs px-2 py-1',
    sm: 'text-sm px-3 py-1.5'
  };
  return <GradientWrapper radius="100px" paddingPx={1} data-id="element-1242">
      <button onClick={onClick} className={`bg-white hover:bg-gray-50 transition-colors font-medium ${sizeClasses[size]} ${className}`} style={{
      borderRadius: 'calc(100px - 1px)'
    }} data-id="element-1243">
        {children}
      </button>
    </GradientWrapper>;
};
export default GradientChip;